import React, {useEffect, useState} from 'react';
import ReportUtils from "../../../../../../utils/report-utils.js";
import NoDataRow from "../../../../../../components/reports/no-data-row.jsx";

const BosReasonContent = ({ data, boName }) => {
    const bos = data?.bos_nature ?? [];

    const [limit, setLimit] = useState(10)
    const passedLimit = bos.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 10)
    }

    useEffect(() => {
        if (!bos?.length) return;
        const values = [];

        bos.map((element) => {
            values.push([
                element.nature,
                element.qty
            ]);
        })

        ReportUtils.createExportableTable(["Natureza", "Quantidade"], values, `${boName} por natureza`);
    }, [data]);

    return (
        <>
            <div className="mt-4">
                <span className="chart-title mb-2">{boName} por natureza {(passedLimit && limit) ? ` (TOP ${limit})` : ''}</span>
                <table id="bos-by-reason-data" className="table report-table mt-2" sheet-name={`${boName} por natureza`}>
                    <thead className="thead-background">
                        <tr className="text-left">
                            <th className="w-[85%]">Natureza</th>
                            <th className="w-[15%]">Quantidade</th>
                        </tr>
                    </thead>

                    <tbody>
                        { !bos?.length ? (
                            <NoDataRow colSpan={2} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : (limit ? bos.slice(0, limit) : bos).map((element, index) => (
                            <tr key={index}>
                                <td className="w-[85%]">{element.nature}</td>
                                <td className="w-[15%]">{element.qty}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                { passedLimit &&
                    <div className="text-end mt-1">
                        <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                            {limit ? "Ver mais" : "Ver menos"}
                        </span>
                    </div>
                }

            </div>

            <div className="chart-divisor print:hidden"/>
        </>
    );
};

export default BosReasonContent;